import authApiService from "./userApiService";

const handleError = (error) => {
  console.error('API Error:', error);
  return {
    success: false,
    error: error.response?.data?.error || error.message || 'An error occurred',
    statusCode: error.response?.status
  };
};

const handleSuccess = (response) => ({
  success: true,
  data: response.data,
  statusCode: response.status
});


export const otherTipsService = {
  async getBalances(role, params = {}) {
    try {
      const response = await authApiService.get("/other-tips/balances", {
        params: { role, ...params }
      });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getEmployees() {
    try {
      const response = await authApiService.get("/other-tips/employees");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getTipHistory(role, startDate = null, endDate = null) {
    try {
      let url = `/other-tips/history?role=${role}`;
      if (startDate && endDate) {
        url += `&startDate=${startDate}&endDate=${endDate}`;
      }
      const response = await authApiService.get(url);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async addRecord(data) {
    try {
      const response = await authApiService.post("/other-tips/", data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async updateRecord(id, data) {
    try {
      const response = await authApiService.put(`/other-tips/${id}`, data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async deleteRecord(id) {
    try {
      const response = await authApiService.delete(`/other-tips/${id}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  }
};